module.exports = __webpack_public_path__ + "img/back-arrow.acf873ac.svg";